import { useEffect, useRef, useState } from 'react';

// Estado de filtros de Jornadas, compartido entre el listado y la subpágina
// de una jornada. Por defecto, en el lado privado con jugador identificado
// se arranca en "solo mis partidos"; en cuanto se activa el interruptor de
// "ver todos" queda así hasta que el usuario lo cambie (no se vuelve a
// forzar aunque tarde en resolver quién es el usuario).
export function useFiltroJornadas({ esPrivado, jugadorId }) {
  const [soloMios, setSoloMios] = useState(false);
  const [modalidad, setModalidad] = useState('Todos');
  const [busqueda, setBusqueda] = useState('');
  const autoAplicado = useRef(false);

  useEffect(() => {
    if (!autoAplicado.current && esPrivado && jugadorId != null) {
      setSoloMios(true);
      autoAplicado.current = true;
    }
  }, [esPrivado, jugadorId]);

  const puedeFiltrarMios = esPrivado && jugadorId != null;

  return { soloMios: puedeFiltrarMios && soloMios, setSoloMios, puedeFiltrarMios, modalidad, setModalidad, busqueda, setBusqueda };
}
